import { Directive, ElementRef, Input, NgZone } from '@angular/core';


declare const Hls: any;

@Directive({
  selector: 'video[hlsSource]'
})
export class HlsVideoPlayerDirective {

  constructor(
    readonly elementRef: ElementRef,
    readonly ngZone: NgZone,
  ) {}

  @Input()
  set hlsSource(source: string) {
    if (typeof window === 'undefined')
      return;
    
    if (source) {
      if (
        navigator.userAgent.includes('Safari/') &&
        !navigator.userAgent.includes('Chrome/') &&
        this.elementRef.nativeElement.canPlayType('application/vnd.apple.mpegurl')
      ) {
        this.setNativeSrc(source);
      } else {
        this.setHlsSource(source);
      }
    }
  }

  private setNativeSrc(source: string) {
    this.elementRef.nativeElement.setAttribute('src', source);
  }

  private setHlsSource(source: string) {
    this.ngZone.runOutsideAngular(() => {
      const hls = new Hls();
      hls.loadSource(source);
      hls.attachMedia(this.elementRef.nativeElement);
    });
  }
}
